import React from "react";

type DropdownItemProps = {
  icon: React.ReactNode;
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  children: React.ReactNode;
};

export const DropdownItem = ({ icon, href, onClick, children }: DropdownItemProps) => {
  const className = "flex items-center w-full gap-3 px-2 py-1.5 rounded-lg hover:bg-[#F5F5F5] transition-colors text-left";

  const content = (
    <>
      <span className="flex items-center justify-center w-8 h-8 shrink-0 text-[#212121]">{icon}</span>
      <span className="text-[#212121] text-sm">{children}</span>
    </>
  );

  if (!href) {
    return (
      <button type="button" onClick={onClick} className={className}>
        {content}
      </button>
    );
  }

  return (
    <a href={href} onClick={onClick} className={className}>
      {content}
    </a>
  );
};

export const DropdownDivider = () => <hr className="my-2 border-[#E0E0E0]" />;

export const DropdownContainer = ({ children }: { children: React.ReactNode }) => (
  <nav className="absolute right-0 top-[calc(100%+12px)] w-[280px] bg-white rounded-2xl p-3 z-[60] shadow-[rgba(0,0,0,0.12)_0px_8px_30px_0px,rgba(0,0,0,0.06)_0px_2px_6px_0px]">
    {children}
  </nav>
);
